import { ServerResponse } from 'http'

export default function locationTemporaryRewrite(
  res: ServerResponse,
  newLocation: string,
) {
  res.writeHead(302, {
    Location: newLocation,
    'Content-Type': 'text/html; charset=utf-8',
  })
  res.end()
}
